// 2k: 404 ohne Typnamen, Symbole und Dashboard – zwei Zeilen, ein Knopf.
import React from "react";
import { Link } from "react-router-dom";
import brandMark from "@/assets/brand/f4s-logo.png";

export default function NotFoundPage() {
  return (
    <main className="min-h-screen bg-[var(--fts-neutral-50)] flex flex-col items-center justify-center px-6 py-12" data-testid="not-found-page">
      <img src={brandMark} alt="Flex4Success" data-testid="not-found-brand" className="h-10 w-auto mb-8 opacity-80" />
      <div className="max-w-lg text-center">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight" data-testid="not-found-headline">
          Diese Seite gibt es nicht.
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed" data-testid="not-found-copy">
          Vielleicht ist der Link alt. Hier geht es weiter:
        </p>
        <Link to="/" data-testid="not-found-cta-home"
          className="mt-8 inline-flex min-h-[48px] items-center rounded-xl bg-[#4563BB] px-6 font-bold text-white hover:bg-[#3a54a0]">
          Zur Startseite
        </Link>
      </div>
    </main>
  );
}
